import { ICreateAndUpdateFinancialGroup } from "../../../types/financialGroup";
import customAxios from "../../customAxios";
import { CREATE_FINANCIAL_GROUP } from "../../routes";

const createFinancialGroup = async (
  formData: ICreateAndUpdateFinancialGroup
) => {
  console.log(formData);

  try {
    return (
      await customAxios.post(CREATE_FINANCIAL_GROUP, {
        ...formData,
      })
    ).data;
  } catch (error: unknown) {
    console.error(error);
    return false;
  }
};

export default createFinancialGroup;
